<template lang="pug">
  .component-create-entity-button
    ModalReveal
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .columns
          label Name
            input(type="text", v-model="clientType.name")
        .columns
          label Group
            select(v-model="clientType.type")
              option PRIVATE
              option BUSINESS
              option MAINTENANCE
      .row.columns.text-center
        button.button(@click="save") Save Client Type
</template>
<script type="text/babel">
  import ModalReveal from '../../foundation/ModalReveal'
  import EditReportingType from '../../../../pages/backoffice/EditReportingType'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'

  export default {
    name: 'CreateClientTypeButtonModal',
    components: {EditReportingType, ModalReveal},
    data() {
      return {
        clientType: {
          name: null,
          type: 'PRIVATE'
        }
      }
    },
    created() {
    },
    methods: {
      save() {
        KeplerBackofficeSdk.clientTypes.make(this.clientType, (data) => {
          window.location.reload()
        })
      }
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateClientTypeButtonModal.vue?0084ad96